/** 控制台 · 额度记录页（pages/console/billing.tsx）。 */
const messages = {
  'page.title': '额度记录',
  'page.descriptionTopup':
    '可以在下方在线充值稳定币，也可以联系运营线下开通。每一笔变动都记录在下方流水中，币种 {currency}。',
  'page.description':
    '额度通过线下付款开通，运营核对单号后发放。每一笔变动都记录在下方流水中，币种 {currency}。',

  'summary.loadError': '额度加载失败',
  'summary.available': '可用',
  'summary.reserved': '冻结中',
  'summary.granted': '累计发放',
  'summary.settled': '累计结算',

  'redeem.title': '兑换码',
  'redeem.desc': '输入兑换码，额度立即到账。每个兑换码同一账号只能兑换一次。',
  'redeem.label': '兑换码',
  'redeem.placeholder': '例如 ABCD-EFGH-JKMN-PQRS',
  'redeem.submit': '兑换',
  'redeem.success': '兑换成功，已到账 {amount}',
  'redeem.failed': '兑换失败',

  'ledger.title': '额度流水',
  'ledger.loaded': '第 {page} 页 · 本页 {n} 条',
  'ledger.loading': '正在加载…',
  'ledger.typeLabel': '流水类型',
  'ledger.allTypes': '全部类型',
  'ledger.loadError': '流水加载失败',
  'ledger.emptyType': '没有“{type}”类型的流水，换个类型看看。',
  'ledger.empty': '还没有额度流水。联系运营线下付款开通额度后，发放记录会出现在这里。',
  'ledger.emptyContact': '运营邮箱：{email}',
  'ledger.balance': '余额',
  'ledger.reference': '单号 {ref}',

  'table.time': '时间',
  'table.type': '类型',
  'table.amount': '金额',
  'table.availableAfter': '变动后可用',
  'table.related': '关联',
  'table.note': '说明',
};

export default messages;
